import { render, staticRenderFns } from "./edit_items.vue?vue&type=template&id=7f23efbc&scoped=true&"
import script from "./edit_items.vue?vue&type=script&lang=js&"
export * from "./edit_items.vue?vue&type=script&lang=js&"
import style0 from "./edit_items.vue?vue&type=style&index=0&id=7f23efbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23efbc",
  null
  
)

export default component.exports